module.exports = __webpack_public_path__ + "static/media/crwn-clothing.86913592.webp";